import DoodleMouthBouche1 from './bouche-1';
import DoodleMouthBouche2 from './bouche-2';
import DoodleMouthBouche3 from './bouche-3';
import DoodleMouthBouche4 from './bouche-4';
import DoodleMouthBouche5 from './bouche-5';
import DoodleMouthBouche6 from './bouche-6';
import DoodleMouthBouche7 from './bouche-7';
import DoodleMouthBouche8 from './bouche-8';
import DoodleMouthBouche9 from './bouche-9';
import DoodleMouthBouche10 from './bouche-10';
import DoodleMouthBouche11 from './bouche-11';

export {
	DoodleMouthBouche1,
	DoodleMouthBouche2,
	DoodleMouthBouche3,
	DoodleMouthBouche4,
	DoodleMouthBouche5,
	DoodleMouthBouche6,
	DoodleMouthBouche7,
	DoodleMouthBouche8,
	DoodleMouthBouche9,
	DoodleMouthBouche10,
	DoodleMouthBouche11
};

// keys are saved in doodle configurations: never rename or remove one
export const DoodleMouthParts = {
	'bouche-1': DoodleMouthBouche1,
	'bouche-2': DoodleMouthBouche2,
	'bouche-3': DoodleMouthBouche3,
	'bouche-4': DoodleMouthBouche4,
	'bouche-5': DoodleMouthBouche5,
	'bouche-6': DoodleMouthBouche6,
	'bouche-7': DoodleMouthBouche7,
	'bouche-8': DoodleMouthBouche8,
	'bouche-9': DoodleMouthBouche9,
	'bouche-10': DoodleMouthBouche10,
	'bouche-11': DoodleMouthBouche11
};

export type DoodleMouthKey = keyof typeof DoodleMouthParts;
